import { MeshPhysicalMaterial, ShaderChunk } from 'three';

// three's direct diffuse light for physical materials: the one line the flesh shading replaces.
const plainDiffuse = 'reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution ) * ( 1.0 - F );';

// Light that wraps a little past the edge of the shadow, reddened by the blood under the skin, instead of stopping
// hard as on a plastic doll.
const fleshDiffuse = /* glsl */ `
	float fleshWrapped = saturate( ( dot( geometryNormal, directLight.direction ) + FLESH_WRAP ) / ( 1.0 + FLESH_WRAP ) );
	vec3 fleshLight = directLight.color * ( fleshWrapped + FLESH_SCATTER * max( fleshWrapped - dotNL, 0.0 ) );
	reflectedLight.directDiffuse += fleshLight * BRDF_Lambert( material.diffuseContribution ) * ( 1.0 - F );`;

const fleshDefines = /* glsl */ `
#define FLESH_WRAP 0.4
#define FLESH_SCATTER vec3( 0.5, 0.17, 0.09 )
`;

/**
 * Skin that reads as skin: matte, with a faint broad highlight rather than a lacquered shine, and light that softens
 * and reddens where it turns into shadow, the way it scatters under real skin. Painted: the model's vertex colours
 * (a flush on the cheeks, shade in the creases) tint it.
 */
export function fleshMaterial(colour: number, painted = false): MeshPhysicalMaterial {
  const material = new MeshPhysicalMaterial({ color: colour, roughness: 0.62, specularIntensity: 0.4, vertexColors: painted });
  material.onBeforeCompile = (shader) => {
    const chunk = ShaderChunk.lights_physical_pars_fragment;
    if (!chunk.includes(plainDiffuse)) throw new Error("three's lighting code changed: the flesh shading cannot find the line it replaces");
    shader.fragmentShader = shader.fragmentShader.replace('#include <lights_physical_pars_fragment>', fleshDefines + chunk.replace(plainDiffuse, fleshDiffuse));
  };
  material.customProgramCacheKey = () => 'flesh';
  return material;
}
